/* eslint-disable react/prop-types */
import React, { Component } from 'react'
import Modal from 'react-modal'
import ReportsCard from './ReportsCard'
import ReportsThumbCard from './ReportsThumbCard'
import PageHeader from '../common/PageHeader/PageHeader'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withTranslation } from 'react-i18next'

import HowToUseAppGuide from './HowToUseAppGuide/HowToUseAppGuide'
import AdminExportsContainer from '../exports/AdminExportsContainer'

import communityRounds from '../../assets/images/report-previews/comm-rounds-report.png'
import communityStats from '../../assets/images/report-previews/comm-stats-report.png'
import communityTraining from '../../assets/images/report-previews/comm-training-report.png'
import facilityImpact from '../../assets/images/report-previews/facility-impact-report.png'
import playerJourney from '../../assets/images/report-previews/player-journey-report.png'
import golferActivity from '../../assets/images/report-previews/golfer-activity-summary.png'
import golferCurriculum from '../../assets/images/report-previews/golfer-curriculum-summary.png'
import golferEngagement from '../../assets/images/report-previews/golfer-engagement-summary.png'
import juniorDev from '../../assets/images/report-previews/junior-dev-model.png'
import onCourse from '../../assets/images/report-previews/on-course-journey.png'

import * as commonActions from '../../actions/commonActions'
import * as userActions from '../../actions/userActions'


class ChooseReports extends Component {
  constructor(props) {
    super(props)

    this.state = {
      guideModalOpen: false,
      downloadPDFLoader: false,
    }
    this.reports = this.props.current_user.type === 'Admin' ? [
      {
        nameKey: 'reports.chooseReports.coachEngagement.name',
        summaryKey: 'reports.chooseReports.coachEngagement.summary',
        reportType: 'coach_engagement',
      },
      {
        nameKey: 'reports.chooseReports.supportActivity.name',
        summaryKey: 'reports.chooseReports.supportActivity.summary',
        reportType: 'support_activity',
      },
      {
        nameKey: 'reports.chooseReports.communityPriority.name',
        summaryKey: 'reports.chooseReports.communityPriority.summary',
        reportType: 'community_priority',
      },
      // {
      //   name: "Admin Community Report",
      //   summary: `This provides a summary of all of the communities in Op36 Program and their associated coaches`,
      //   reportType: "admin-community"
      // }
    ] : [
      {
        nameKey: 'reports.chooseReports.playerJourney.name',
        summaryKey: 'reports.chooseReports.playerJourney.summary',
        reportType: 'player_journey',
        image: playerJourney,
      },
      {
        nameKey: 'reports.chooseReports.impact.name',
        summaryKey: 'reports.chooseReports.impact.summary',
        reportType: 'impact',
        image: facilityImpact,
      },
      {
        nameKey: 'reports.chooseReports.progress.name',
        summaryKey: 'reports.chooseReports.progress.summary',
        reportType: 'progress',
        image: juniorDev,
      },
      {
        nameKey: 'reports.chooseReports.community.name',
        summaryKey: 'reports.chooseReports.community.summary',
        reportType: 'community',
        image: communityStats,
      },
      {
        nameKey: 'reports.chooseReports.communityRounds.name',
        summaryKey: 'reports.chooseReports.communityRounds.summary',
        reportType: 'community_rounds',
        image: communityRounds,
      },
      {
        nameKey: 'reports.chooseReports.communityPractice.name',
        summaryKey: 'reports.chooseReports.communityPractice.summary',
        reportType: 'community_practice',
        image: communityTraining,
      },
      {
        nameKey: 'reports.chooseReports.curriculum.name',
        summaryKey: 'reports.chooseReports.curriculum.summary',
        reportType: 'curriculum',
        image: golferCurriculum,
      },
      {
        nameKey: 'reports.chooseReports.engagement.name',
        summaryKey: 'reports.chooseReports.engagement.summary',
        reportType: 'engagement',
        image: golferEngagement,
      },
      {
        nameKey: 'reports.chooseReports.stats.name',
        summaryKey: 'reports.chooseReports.stats.summary',
        reportType: 'stats',
        image: golferActivity,
      },
      {
        nameKey: 'reports.chooseReports.rounds.name',
        summaryKey: 'reports.chooseReports.rounds.summary',
        reportType: 'rounds',
        image: onCourse,
      },
    ]
  }

  _toggleGuideModal = () => {
    this.setState((prevState) => ({
      guideModalOpen: !prevState.guideModalOpen,
    }))
  }

  viewReport = (type) => {
    this.props.viewReport(type)
    this.props.next()
  }

  renderReports() {
    const { t } = this.props
    if (this.props.current_user.type === 'Admin') {
      return (
        <>
          <PageHeader title={t('reports.chooseReports.pageTitle')} />
          <div className='container my-5 animated fadeIn'>
            <div className='card p-4'>
              {this.reports.map((report, index) => (
                <ReportsCard
                  key={index}
                  reportName={t(report.nameKey)}
                  summary={t(report.summaryKey)}
                  viewReport={this.viewReport}
                  reportType={report.reportType} />
              ))}
            </div>
            <AdminExportsContainer />
          </div>
        </>
      )
    }

    const { guideModalOpen } = this.state
    const commId = this.props.current_user.communities[0].id

    const headerActionLink = (
      <button
        className='no-bg-text-btn'
        onClick={this._toggleGuideModal}
        style={{ fontSize: '16px', marginLeft: '36px' }}
      >
        <i className='fa fa-file-pdf-o' aria-hidden='true' /> {t('reports.chooseReports.increaseUsage')}
      </button>
    )

    return (
      <div>
        <PageHeader title={t('reports.chooseReports.pageTitle')} actionComponent={headerActionLink}/>
        <Modal
          id='HowToUseAppGuide'
          isOpen={guideModalOpen}
          onRequestClose={this._toggleGuideModal}
          contentLabel={t('reports.chooseReports.guideModalContentLabel')}
        >
          <div className='modal-header row m-0 p-0'>
            <div className='col-11 m-0 p-0'>
              <h5 className='modal-title display-4'>
                {t('reports.chooseReports.guideModalTitle')}
              </h5>
            </div>
            <div className='col-1 m-0 p-0'>
              <button
                type='button'
                className='close pull-right font-200'
                data-dismiss='modal'
                aria-label={t('common.close')}
                onClick={this._toggleGuideModal}
              >
                <span aria-hidden='true'>✕</span>
              </button>
            </div>
          </div>
          <HowToUseAppGuide commId={commId} />
        </Modal>
        <div className='coach-report-container d-flex flex-grow-1 flex-wrap'>
          {this.reports.map((report, index) => (
            <ReportsThumbCard
              key={index}
              reportName={t(report.nameKey)}
              summary={t(report.summaryKey)}
              viewReport={this.viewReport}
              reportType={report.reportType}
              image={report.image}
            />
          ))}
        </div>
      </div>
    )
  }

  render() {
    return this.renderReports()
  }
}

function mapStateToProps(state, _ownProps) {
  return {
    current_user: state.user.current_user,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    common_actions: bindActionCreators(commonActions, dispatch),
    user_actions: bindActionCreators(userActions, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ChooseReports))
